export default function isDate(date : any) : date is Date {
	return Object.prototype.toString.call(date) === '[object Date]'
}